import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectResourceApplicationApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-resource-application'
  }

}